/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import controlIcons from '../../../constants/icons';

// container
export const C_BORDER = 'cBorder';
export const C_BRADIUS = 'cBradius';
export const C_MARGIN = 'cMargin';
export const C_PADDING = 'cPadding';
export const C_BG = 'cBg';

// title
export const T_TYPO = 'tTypo';
export const I_BG = 'iBg';
export const I_BORDER = 'iBorder';
export const I_BRADIUS = 'iBradius';
export const I_PADDING = 'iPadding';
export const I_SIZE = 'iSize';

export const T_MARGIN = 'tMargin';
export const Q_TYPO = 'qTypo';
export const Q_MARGIN = 'qMargin';

// Item
export const ITEM_ALIGN = 'itemAlign';
// rating
export const RATING_SIZE = 'ratingSize';
// numeric rating
export const NR_TYPO = 'nrTypo';
export const NR_GAP = 'nrGap';
// title
export const TITLE_TYPO = 'titleTypo';
export const TITLE_GAP = 'titleGap';
